<template>
  <div class="my-wrap">
    <div v-if="isDepositEventsVisible" class="my-deposit-frame">
      <div class="my-deposit my-d-box">
        <!-- 手機版流程-->
        <div class="my-deposit-package-mobile">
          <div class="mobile-frame">
            <div class="channel-text-n">
              {{ $t('Bao.deposit_select') }}
            </div>
            <!-- 上方選單 -->
            <div class="mobile-frame">
              <div class="mobile-wallet-card">
                <div class="wallet-list-on">
                  {{ $t('Bao.deposit') }}
                </div>
                <div class="wallet-list" @click="$router.push('/withdrawal')">
                  {{ $t('Bao.withdraw_menu') }}
                </div>
                <div class="wallet-list" @click="$router.push('/user/wallet-history')">
                  {{ $t('Bao.transaction-index') }}
                </div>
              </div>
              <div class="deposit-bg">
                <div v-if="outerTypes && outerTypes.length > 0" class="bank-choice">
                  <div
                    v-if=" outerTypes[0].paymentMethods.length > 0"
                    class="bank-electron"
                    :class="{ active: selectedType === 1 }"
                    @click.stop="selectType(1)"
                  >
                    <p> {{ $t('Bao.channel_epay') }}</p>
                  </div>
                  <div
                    v-if=" outerTypes[1].paymentMethods.length > 0"
                    class="bank-bank"
                    :class="{ active: selectedType === 2}"
                    @click.stop="selectType(2)"
                  >
                    <p> {{ $t('Bao.channel_bank') }}</p>
                  </div>
                  <div
                    v-if=" outerTypes[2].paymentMethods.length > 0"
                    class="bank-bitcoin"
                    :class="{ active: selectedType === 3 }"
                    @click.stop="selectType(outerTypes[2].type)"
                  >
                    <p>{{ $t('Bao.channel_crypto') }}</p>
                  </div>
                  <div
                    v-if=" outerTypes[3].paymentMethods.length > 0"
                    class="bank-credit-card"
                    :class="{ active: selectedType === 4 }"
                    @click.stop="selectType(outerTypes[3].type)"
                  >
                    <p>{{ $t('Bao.credit_card') }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 電子銀行 -->
            <div class="mobile-frame">
              <div
                v-if="outerTypes && outerTypes.length > 0 && selectedType"
                class="deposit-frame-n"
              >
                <p>{{ $t('Bao.payment_select') }}</p>
              </div>
              <div
                v-if="outerTypes && outerTypes.length > 0 && selectedType"
                class="channel-bank-frame"
              >
                <div
                  v-for="payment in outerTypes[selectedType - 1].paymentMethods"
                  :key="payment.payment_id"
                  class="channel-bank-card-n"
                  :class="{ 'channel-bank-card-on': isSelectedPayment(payment) }"
                >
                  <div
                    class="bank-choice-text grid-container"
                    @click.stop="selectPayment(payment, payment.name, payment.typeCode)"
                  >
                    <div><img :src="payment.image" alt=""></div>
                    <div>
                      <p class="channel-name-n">
                        {{ payment.name }}
                      </p>
                    </div>
                    <p class="describe-n">
                      {{ $t('Bao.min_to_max') }}:{{ payment.amount_limit.min }}-{{ payment.amount_limit.max }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- 手機 電子錢包+銀行 金額輸入 -->
              <div
                v-if="selectedPayment && (selectedPayment.typeNum !== 3 && selectedPayment.typeCode !== 'PayPal'&& selectedPayment.typeCode !== 'JetonCash'|| selectedPayment.code === 'HeroPay')"
                class="slider-form"
              >
                <div class="my-wallet-frame-n2">
                  <div class="form-input-n input-frame">
                    <div class="input-title">
                      {{ $t('Bao.amount') }} :
                    </div>
                    <div>
                      <input
                        v-model="postForm.amount"
                        :placeholder="$t('Bao.crypto_placeholder')"
                        type="text"
                        @input="validateNumber"
                      >
                    </div>
                  </div>

                  <div
                    v-if="selectedPayment && selectedPayment.name === 'JetonPay'"
                    class="slider form-input-n2"
                  >
                    <label class="dp-title">{{ $t('Bao.jeton_account') }}</label>
                    <input
                      v-model="other.uid"
                      type="text"
                      :placeholder="$t('Bao.jeton_account')"
                      @input="checkJetonErrors"
                    >
                    <div v-for="error in jetonErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                  </div>
                  <div
                    v-if="selectedPayment && selectedPayment.name === 'VegaWallet'"
                    class="slider form-input-n2"
                  >
                    <label class="dp-title">{{ $t('Bao.deposit_account') }}</label>
                    <input
                      v-model="other.uid"
                      type="text"
                      :placeholder="$t('Bao.deposit_account')"
                      @input="checkAccountErrors"
                    >
                    <div v-for="error in accountErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                    <label class="dp-title">{{ $t('Bao.deposit_password') }}</label>
                    <input
                      v-model="other.password"
                      v-validate="'required'"
                      name="password"
                      type="password"
                      :placeholder="$t('Bao.deposit_password')"
                    >
                    <div v-if="errors.has('password')" class="help-block">
                      {{ $t("Bao.deposit_password_error") }}
                    </div>
                  </div>
                </div>
                <template>
                  <div class="slider">
                    <div
                      class="slider-number"
                    >
                      <li
                        v-for="(price, key) in selectedPayment.price_list.slice(0,5)"
                        :key="key"
                        @click="handleAmount(price)"
                      >
                        {{ price | numberFormat }}
                      </li>
                    </div>
                    <div class="slider-dot">
                      <li
                        v-for="(price, key) in selectedPayment.price_list.slice(0,5)"
                        :key="key"
                        @click="handleAmount(price)"
                      >
                        <img :src="getThemeImagePath('dot.svg')" alt="">
                      </li>
                    </div>

                    <div class="slider-bar" />
                    <div
                      v-show="selectedAmount"
                      class="slider-bar og"
                      :style="{ width: percent + '%' }"
                    >
                      <img :src="getThemeImagePath('dot-orange.svg')" alt="">
                    </div>
                  </div>
                </template>
              </div>
              <!-- 仮想通貨 -->
              <div v-show="selectedPayment && selectedPayment.typeNum === 3">
                <!-- 加密貨幣渠道下拉選單-->
                <div class="form-section-n bank-promo-n">
                  <crypto-selector
                    v-model="selectedCrypto"
                    :filtered-types="filteredTypes"
                    @change="handleCryptoSelection"
                  />
                </div>

                <!-- 相場確認 -->
                <div class="crypto-frame">
                  <div class="my-wallet-frame-n2 ">
                    <div class="input-frame">
                      <div class="input-title">
                        {{ $t('Bao.amount') }}
                      </div>
                      <div>
                        <input
                          v-model="cryptoAmount"
                          :placeholder="$t('Bao.crypto_placeholder')"
                          type="text"
                          @input="validateNumber"
                        >
                      </div>
                      <div class="input-title">
                        JPY
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="selectedPayment " class="crypto">
                  <div class="exchange-rate-box-n">
                    <div v-if="!timeLeft" class="exchange-rate">
                      <span class="crypto-amount">{{ $t('Bao.current_rate') }}:</span>
                      <span class="crypto-type">{{ $t('Bao.expired_rate', { crypto: currencyRate.fetchName }) }}</span>
                    </div>
                    <div v-if="timeLeft > 0" class="exchange-rate">
                      <span class="crypto-type">1JPY = {{ currencyRate.deposit_divide }}{{ currencyRate.fetchName }}</span>
                    </div>
                    <div v-if="timeLeft > 0" class="exchange-rate">
                      <span class="crypto-type">{{ cryptoAmount }}JPY = {{ currencyRate.currencyRate }}{{ currencyRate.fetchName }}</span>
                    </div>
                  </div>
                  <div class="recheck-bn">
                    <div v-if="timeLeft > 0" div class="countdown-box">
                      {{ formattedTime }}
                    </div>
                    <div v-else @click="handleRecheckFortype3(currencyRate.payment_id)">
                      {{ $t('Bao.refresh_rate') }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="selectedPayment && selectedPayment.typeCode === 'JetonCash'">
                <!-- 加密貨幣渠道下拉選單-->
                <div class="form-section-n bank-promo-n">
                  <label class="dp-title">{{ $t('Bao.currency') }}</label>
                  <select id="Jcash_EUR" v-model="Jcash.currency" class="crypto-items">
                    <option value="EUR">
                      EUR
                    </option>
                  </select>
                </div>

                <!-- 相場確認 -->
                <div class="crypto-frame">
                  <div class="my-wallet-frame-n2 ">
                    <div class="input-frame">
                      <div class="input-title">
                        {{ $t('Bao.amount') }}
                      </div>
                      <div>
                        <input
                          v-model="cryptoAmount"
                          :placeholder="$t('Bao.crypto_placeholder')"
                          type="text"
                          @input="validateNumber"
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="selectedPayment && selectedPayment.typeCode === 'JetonCash'"
                  class="crypto"
                >
                  <div class="slider form-input-n2">
                    <label class="dp-title">{{ $t('Bao.jeton_label') }}</label>
                    <input
                      v-model="Jcash.voucherNumber"
                      type="text"
                      :placeholder="$t('Bao.jeton_voucher')"
                      @input="checkJetonVoucherErrors"
                    >
                    <div v-for="error in jetonVoucherErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                  </div>
                  <div class="jcash-container form-input-n2">
                    <div class="jcash-wrap">
                      <!-- Expiration Date Field -->
                      <label class="dp-title">{{ $t('Bao.expiration_date') }}</label>
                      <input
                        v-model="Jcash.expirationDate"
                        maxlength="5"
                        type="text"
                        :placeholder="$t('Bao.expiration_date_placeholder')"
                        @input="formatJcashExpirationDate"
                      >

                      <div v-for="error in JcashExpirationDateErrors" :key="error" class="help-block">
                        {{ error }}
                      </div>
                    </div>
                    <div class="jcash-wrap">
                      <!-- Security Code Field -->
                      <label class="dp-title">{{ $t('Bao.security_code') }}</label>
                      <input
                        v-model="Jcash.securityCode"
                        type="text"
                        :placeholder="$t('Bao.security_code_placeholder')"
                        maxlength="4"
                        @input="formatJcashSecurityCode"
                      >

                      <div v-for="error in JcashSecurityCodeErrors" :key="error" class="help-block">
                        {{ error }}
                      </div>
                    </div>
                  </div>
                  <div class="exchange-rate-box-n">
                    <div v-if="!timeLeft" class="exchange-rate">
                      <span class="crypto-amount">{{ $t('Bao.current_rate') }}:</span>
                      <span class="crypto-type">{{ $t('Bao.expired_rate', { crypto: 'EUR€' }) }}</span>
                    </div>
                    <div v-if="timeLeft > 0" class="exchange-rate">
                      <span class="crypto-type">1EUR€ = {{ currencyRate.deposit_rate }}JPY</span>
                    </div>

                    <div v-if="timeLeft > 0" class="exchange-rate">
                      <span class="crypto-type">
                        {{ cryptoAmount }} EUR€ = {{ currencyRate.currencyRate }}JPY
                      </span>
                    </div>
                  </div>
                  <div class="recheck-bn">
                    <div v-if="timeLeft > 0" div class="countdown-box">
                      {{ formattedTime }}
                    </div>
                    <div v-else @click="handleRecheck(selectedPayment.payment_id)">
                      {{ $t('Bao.refresh_rate') }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="selectedPayment && selectedPayment.typeCode === 'CreditCard'&& selectedPayment.code !== 'HeroPay'"
                class="slider credit-card-dep-form"
              >
                <legend class="form-leggend">
                  {{ $t('Bao.payment_info') }}
                </legend>

                <div class="form-input-package form-mb">
                  <div class="col-input-title">
                    <label class="title col-2" for="credit-select"> {{ $t('Bao.credit_card_num') }}<span class="t-highlight-orange D-none">*</span></label>
                  </div>
                  <div class="col-input pos-relative">
                    <div class="icon-drop" />
                    <select
                      id="credit-select"
                      v-model="selectedCreditCard"
                      class="form-control dep-input-icon-credit"
                    >
                      <option
                        v-for="(type, key) in creditCard.credit_card_number"
                        :key="key"
                        :value="type"
                        class="creditCard"
                        selected=""
                      >
                        {{ type.credit_card_number }}
                      </option>
                    </select>
                  </div>
                  <a class="btn btn-credit-add" @click="$router.push({ path: '/user/bank' })">
                    <span class="icon-add-circle">+</span>
                    <span> {{ $t('Bao.credit_card_add') }}</span>
                  </a>
                  <div v-for="error in jetonVoucherErrors" :key="error" class="invalid_feedback ">
                    {{ error }}
                  </div>
                </div>
                <div class="form-input-package form-mb">
                  <div class="col-input-title">
                    <label class="title col-2" for="cardholder">
                      {{ $t('Bao.cardholder') }}
                      <span class="t-highlight-orange D-none">*</span></label>
                  </div>
                  <div class="col-input">
                    <input
                      id="cardholder"
                      v-model="creditCard.card_printed_name"
                      class="form-control dep-input-icon-user"
                      type="text"
                      placeholder="TANAKA TARO"
                      :readonly="selectedCreditCard"
                      :class="{ 'locked-input': selectedCreditCard }"
                      @input="checkCreditCardNameErrors"
                    >
                  </div>
                  <div v-for="error in creditCardNameErrors" :key="error" class="invalid_feedback ">
                    {{ error }}
                  </div>
                </div>
                <div class="form-input-package form-mb">
                  <div class="col-input-title">
                    <label class="title col-2" for="card-date">{{ $t('Bao.credit_card_expire') }}<span class="t-highlight-orange D-none">*</span></label>
                  </div>
                  <div class="col-input">
                    <input
                      id="card-date"
                      v-model="creditCard.expirationDate"
                      class="form-control dep-input-icon-date"
                      type="text"
                      :placeholder="$t('Bao.expiration_date_placeholder')"
                      maxlength="5"
                      :readonly="selectedCreditCard"
                      :class="{ 'locked-input': selectedCreditCard }"
                      @input="formatCreditCardExpirationDate"
                    >
                  </div>
                  <div v-for="error in creditCardExpirationDateErrors" :key="error" class="invalid_feedback ">
                    {{ error }}
                  </div>
                </div>

                <div class="form-input-package form-mb">
                  <div class="col-input-title">
                    <label class="title col-2 d-flex" for="card-security-code">
                      {{ $t('Bao.credit_card_security') }}
                      <span class="t-highlight-orange D-none">*</span>
                      <a class="cvv btn-credit-cvv">CVV
                        <span class="que-mark" @click="showCVV=true">?</span>
                      </a>
                    </label>
                  </div>
                  <div class="col-input">
                    <input
                      id="card-security-code"
                      v-model="creditCard.securityCode"
                      class="form-control dep-input-icon-security-code"
                      type="text"
                      placeholder="123"
                      maxlength="3"
                      @input="formatCreditCardSecurityCode"
                    >
                  </div>
                  <div
                    v-for="error in creditCardSecurityCodeErrors"
                    :key="error"
                    class="invalid_feedback "
                  >
                    {{ error }}
                  </div>
                </div>
              </div>
              <!--仮想通貨 入金選項 end -->
              <div
                v-if="selectedPayment && selectedPayment.typeCode === 'PayPal'"
                class="bank-promo-n "
              >
                <p class="channel-text-n">
                  {{ $t('Bao.prize_select') }}
                </p>
                <ul class="amount-bn">
                  <li
                    v-for="(price, key) in selectedPayment.price_list"
                    :key="key"
                    :class="selectedAmount === price ? 'active' : ''"
                    @click="handleAmount(price)"
                  >
                    ¥{{ price }}
                  </li>
                </ul>
              </div>
              <div v-if="memberInfo.member_type !== 3 && sortedEvents" class="bank-promo-n ">
                <p class="channel-text-n">
                  {{ $t('Bao.available_event') }}
                </p>
                <div class="bank-promo-frame">
                  <swiper
                    ref="mySwiperPhone"
                    class="slick-frame"
                    :options="swiperOptionPhone"
                    :up-text="upText"
                  >
                    <swiper-slide
                      v-for="(item, key) in sortedEvents"
                      :key="key"
                      class="event-pic"
                      :class="{
                        'unopened-event': isUnopenedEvent(item),
                        'unselected': !isUnopenedEvent(item) ,
                        'selected': item.select && selectedEvent !== null
                      }"
                    >
                      <span @click="handleEvent(item)" />
                      <img :src="item.image_deposit" @click="handleEvent(item)">
                    </swiper-slide>

                    <div slot="pagination" class="swiper-pagination" />
                    <div slot="button-prev" class="swiper-button-prev pro-arrow" />
                    <div slot="button-next" class="swiper-button-next pro-arrow" />
                  </swiper>
                </div>
              </div>

              <!--存款計算項目 -->
              <div v-show="selectedPayment && selectedPayment.typeNum !== 3" class="deposit-frame-n">
                <div class="deposit-detail-n">
                  <div class="list">
                    <b>{{ $t('Bao.deposit_amount') }}</b>
                    <span v-if="selectedCrypto">{{ currencyRate.currencyRate | numberFormat }}</span>
                    <span v-else>{{ postForm.amount | numberFormat }}</span>
                    <span>{{ currency }} </span>
                  </div>
                  <div
                    v-if="!selectedEvent || selectedEvent.type !== 'daily_multiple_deposit'"
                    class="list"
                  >
                    <b>{{ $t('Bao.event_bonus') }}</b>
                    <span>{{ eventBonus | numberFormat }}</span>
                    <span>{{ currency }} </span>
                  </div>
                  <div
                    v-if="!selectedEvent || selectedEvent.type !== 'daily_multiple_deposit'"
                    class="list"
                  >
                    <b>{{ $t('Bao.deposit_total_tip') }}</b>
                    <span>{{ calculateTotalBonus() | numberFormat }}</span>
                    <span>{{ currency }} </span>
                  </div>
                </div>
                <div v-if="selectedPayment" class="deposit-detail-n">
                  <p v-if="selectedEvent && selectedEvent.type === 'daily_multiple_deposit'">
                    {{ $t('Bao.deposit_credit') }} {{ count }}
                    <br>
                    {{ $t('Bao.deposit_credit_illustrate') }}
                    <br>
                    <br>
                    <template v-if="selectedPayment.typeNum === 3">
                      {{ $t('Bao.payment_crypto_describe_1') }}
                    </template>
                    <template v-else-if="selectedPayment.name === 'VegaWallet'">
                      {{ $t('Bao.payment_vega_describe_1') }}
                      <br>
                      {{ $t('Bao.payment_vega_describe_2') }}
                      <a
                        href="https://vega-wallet.com/whitelist/"
                        target="_blank"
                        class="blue-link"
                      >
                        {{ $t('Bao.payment_vega_describe_3') }}
                      </a>
                    </template>
                    <template v-else>
                      {{ $t('Bao.payment_bank_describe_1') }}
                      <br>
                      {{ $t('Bao.payment_bank_describe_2') }}
                    </template>
                  </p>
                  <p v-else-if="selectedPayment.name === 'VegaWallet'">
                    {{ $t('Bao.payment_vega_describe_1') }}
                    <br>
                    {{ $t('Bao.payment_vega_describe_2') }}
                    <a
                      href="https://vega-wallet.com/whitelist/"
                      target="_blank"
                      class="blue-link"
                    >
                      {{ $t('Bao.payment_vega_describe_3') }}
                    </a>
                  </p>
                  <p v-else-if="selectedPayment.typeNum === 3">
                    {{ $t('Bao.payment_crypto_describe_1') }}
                  </p>

                  <p v-else>
                    {{ $t('Bao.payment_bank_describe_1') }}
                    <br>
                    {{ $t('Bao.payment_bank_describe_2') }}
                  </p>
                </div>
              </div>

              <div class="bank-promo-n">
                <button class="button-style-16" :disabled="isButtonDisable" @click="checkIsDeposit()">
                  <span>{{ $t('Bao.deposit') }}</span>
                  <span
                    v-show="postForm.amount !== 0 && selectedPayment && selectedPayment.typeNum !== 3 && selectedPayment.typeCode !== 'JetonCash'"
                  >
                    {{ currency }}
                  </span>
                  <span v-if="selectedPayment && selectedPayment.typeNum === 3">
                    {{ formatCryptoAmount() }}{{ currency }}JPY
                  </span>
                  <span v-else-if="selectedPayment && selectedPayment.typeCode === 'JetonCash'">
                    {{ postForm.amount | numberFormat }} EUR€
                  </span>
                  <span v-else>
                    {{ postForm.amount | numberFormat }}
                  </span>
                </button>
                <a
                  class="help-deposit-n"
                  @click="$router.push('/page/support')"
                >
                  <span class="icon-help">?</span>
                  <span class="help-text">{{ $t('Bao.deposit_guide') }}</span></a>
              </div>
            </div>
            <!-- mb 電子錢包+銀行 入金選項 end -->
          </div><!-- mobile-frame end -->
        </div>

        <!-- 電腦版流程-->
        <div class="my-deposit-package-n">
          <div class="channel-text-n">
            {{ $t('Bao.deposit') }}
            <span class="">{{ $t('Bao.payment_select') }}</span>
          </div>
          <div class="my-money my-wallet-frame-n">
            <div
              v-if="outerTypes && outerTypes.length > 0 && outerTypes[0].paymentMethods.length > 0"
              class="wallet-card"
            >
              <div class="bank-choice-item-n bank-choice">
                <img :src="getThemeImagePath('electron-gold.svg')" alt="">
                <div class="bank-choice-text">
                  <div class="bank-card-title">
                    {{ $t('Bao.channel_epay') }}
                  </div>
                  <p class="describe-n">
                    {{ $t('Bao.e-payment') }}
                  </p>
                </div>
              </div>
              <hr>
              <div class="bank-card-s">
                <div v-if="outerTypes && outerTypes.length > 0 " class="channel-wrapper-n">
                  <div
                    v-for="payment in outerTypes[0].paymentMethods"
                    :key="payment.payment_id"
                    class="channel-bank-card-n"
                    :class="{ 'channel-bank-card-on': isSelectedPayment(payment) }"
                  >
                    <div
                      class="bank-choice-text grid-container"
                      @click.stop="selectPayment(payment,payment.name,payment.typeCode)"
                    >
                      <div>
                        <img :src="payment.image" alt="">
                      </div>
                      <div>
                        <p class="channel-name-n">
                          {{ payment.name }}
                        </p>
                        <p class="describe-n">
                          {{ $t('Bao.min_to_max') }}:{{ payment.amount_limit.min }}-{{ payment.amount_limit.max }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="outerTypes && outerTypes.length > 0 && outerTypes[1].paymentMethods.length > 0"
              class="wallet-card"
            >
              <div class="bank-choice-item-n bank-choice">
                <img :src="getThemeImagePath('bankB-gold.svg')" alt="">
                <div class="bank-choice-text">
                  <div class="bank-card-title">
                    {{ $t('Bao.channel_bank') }}
                  </div>
                  <p class="describe-n">
                    {{ $t('Bao.internet_bank_app') }}
                  </p>
                </div>
              </div>
              <hr>
              <div class="bank-card-s">
                <div v-if="outerTypes && outerTypes.length > 0 " class="channel-wrapper-n">
                  <div
                    v-for="payment in outerTypes[1].paymentMethods"
                    :key="payment.payment_id"
                    class="channel-bank-card-n"
                    :class="{ 'channel-bank-card-on': isSelectedPayment(payment) }"
                  >
                    <div
                      class="bank-choice-text grid-container"
                      @click.stop="selectPayment(payment,payment.name,payment.typeCode)"
                    >
                      <div>
                        <img :src="payment.image" alt="">
                      </div>
                      <div>
                        <p class="channel-name-n">
                          {{ payment.name }}
                        </p>
                        <p class="describe-n">
                          {{ $t('Bao.min_to_max') }}:{{ payment.amount_limit.min }}-{{ payment.amount_limit.max }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="outerTypes && outerTypes.length > 0 && outerTypes[2].paymentMethods.length > 0"
              class="wallet-card"
            >
              <div class="bank-choice-item-n bank-choice">
                <img :src="getThemeImagePath('bitcoin-btc-gold.svg')" alt="">
                <div class="bank-choice-text">
                  <div class="bank-card-title">
                    {{ $t('Bao.channel_crypto') }}
                  </div>
                  <p class="describe-n">
                    {{ $t('Bao.bitcoin_ethereum') }}
                  </p>
                </div>
              </div>
              <hr>
              <div class="bank-card-s">
                <div v-if="outerTypes && outerTypes.length > 0" class="channel-wrapper-n">
                  <div
                    v-for="payment in outerTypes[2].paymentMethods"
                    :key="payment.payment_id"
                    class="channel-bank-card-n"
                    :class="{ 'channel-bank-card-on': isSelectedPayment(payment) }"
                  >
                    <div
                      class="bank-choice-text grid-container"
                      @click.stop="selectPayment(payment,payment.name,payment.typeCode)"
                    >
                      <div>
                        <img :src="payment.image" alt="">
                      </div>
                      <div>
                        <p class="channel-name-n">
                          {{ payment.name }}
                        </p>
                        <p class="describe-n">
                          {{ $t('Bao.min_to_max') }}:{{ payment.amount_limit.min }}-{{ payment.amount_limit.max }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="outerTypes && outerTypes.length > 0 && outerTypes[3].paymentMethods.length > 0"
              class="wallet-card"
            >
              <div class="bank-choice-item-n bank-choice">
                <img :src="getThemeImagePath('card-gold.svg')" alt="">
                <div class="bank-choice-text">
                  <div class="bank-card-title">
                    {{ $t('Bao.credit_card') }}
                  </div>
                  <p class="describe-n">
                    {{ $t('Bao.internet_bank_app') }}
                  </p>
                </div>
              </div>
              <hr>
              <div class="bank-card-s">
                <div v-if="outerTypes && outerTypes.length > 0" class="channel-wrapper-n">
                  <div
                    v-for="payment in outerTypes[3].paymentMethods"
                    :key="payment.payment_id"
                    class="channel-bank-card-n"
                    :class="{ 'channel-bank-card-on': isSelectedPayment(payment) }"
                  >
                    <div
                      class="bank-choice-text grid-container"
                      @click.stop="selectPayment(payment,payment.name,payment.typeCode)"
                    >
                      <div>
                        <img :src="payment.image" alt="">
                      </div>
                      <div>
                        <p class="channel-name-n">
                          {{ payment.name }}
                        </p>
                        <p class="describe-n">
                          {{ $t('Bao.min_to_max') }}:{{ payment.amount_limit.min }}-{{ payment.amount_limit.max }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- pc 電子錢包+銀行 金額輸入 -->
          <div class="slider-form">
            <div class="my-wallet-frame-n2">
              <div
                v-if="selectedPayment && (selectedPayment.typeNum !== 3 && selectedPayment.typeCode !== 'PayPal'&& selectedPayment.typeCode !== 'JetonCash')"
                class="form-input-n input-frame"
              >
                <div class="input-title">
                  {{ $t('Bao.amount') }} :
                </div>
                <div>
                  <input
                    v-model="postForm.amount"
                    :placeholder="$t('Bao.crypto_placeholder')"
                    type="text"
                    @input="validateNumber"
                  >
                </div>
              </div>
              <div
                v-if="selectedPayment && selectedPayment.typeCode === 'CreditCard'&& selectedPayment.code !== 'HeroPay'"
                class="slider credit-card-dep-form"
              >
                <legend class="form-leggend">
                  {{ $t('Bao.payment_info') }}
                </legend>

                <div class="form-input-package form-mb">
                  <div class="col-input-title">
                    <label class="title col-2" for="credit-select"> {{ $t('Bao.credit_card_num') }}<span class="t-highlight-orange D-none">*</span></label>
                  </div>
                  <div class="col-input pos-relative">
                    <div class="icon-drop" />
                    <select
                      id="credit-select"
                      v-model="selectedCreditCard"
                      class="form-control dep-input-icon-credit"
                    >
                      <option
                        v-for="(type, key) in creditCard.credit_card_number"
                        :key="key"
                        :value="type"
                        class="creditCard"
                        selected=""
                      >
                        {{ type.credit_card_number }}
                      </option>
                    </select>
                  </div>
                  <a class="btn btn-credit-add" @click="$router.push({ path: '/user/bank' })">
                    <span class="icon-add-circle">+</span>
                    <span> {{ $t('Bao.credit_card_add') }}</span>
                  </a>
                  <div v-for="error in jetonVoucherErrors" :key="error" class="invalid_feedback ">
                    {{ error }}
                  </div>
                </div>
                <div class="form-input-package form-mb">
                  <div class="col-input-title">
                    <label class="title col-2" for="cardholder">
                      {{ $t('Bao.cardholder') }}
                      <span class="t-highlight-orange D-none">*</span></label>
                  </div>
                  <div class="col-input">
                    <input
                      id="cardholder"
                      v-model="creditCard.card_printed_name"
                      class="form-control dep-input-icon-user"
                      type="text"
                      placeholder="TANAKA TARO"
                      :readonly="selectedCreditCard"
                      :class="{ 'locked-input': selectedCreditCard }"
                      @input="checkCreditCardNameErrors"
                    >
                  </div>
                  <div v-for="error in creditCardNameErrors" :key="error" class="invalid_feedback ">
                    {{ error }}
                  </div>
                </div>
                <div class="form-input-package form-mb">
                  <div class="col-input-title">
                    <label class="title col-2" for="card-date">{{ $t('Bao.credit_card_expire') }}<span class="t-highlight-orange D-none">*</span></label>
                  </div>
                  <div class="col-input">
                    <input
                      id="card-date"
                      v-model="creditCard.expirationDate"
                      class="form-control dep-input-icon-date"
                      type="text"
                      :placeholder="$t('Bao.expiration_date_placeholder')"
                      maxlength="5"
                      :readonly="selectedCreditCard"
                      :class="{ 'locked-input': selectedCreditCard }"
                      @input="formatCreditCardExpirationDate"
                    >
                  </div>
                  <div v-for="error in creditCardExpirationDateErrors" :key="error" class="invalid_feedback ">
                    {{ error }}
                  </div>
                </div>

                <div class="form-input-package form-mb">
                  <div class="col-input-title">
                    <label
                      class="title col-2 d-flex"
                      for="card-security-code"
                    >{{ $t('Bao.credit_card_security') }}
                      <span class="t-highlight-orange D-none">*</span>
                      <a class="cvv btn-credit-cvv">CVV
                        <span class="que-mark" @click="showCVV=true">?</span>
                      </a>
                    </label>
                  </div>
                  <div class="col-input">
                    <input
                      id="card-security-code"
                      v-model="creditCard.securityCode"
                      class="form-control dep-input-icon-security-code"
                      type="text"
                      placeholder="123"
                      maxlength="3"
                      @input="formatCreditCardSecurityCode"
                    >
                  </div>
                  <div
                    v-for="error in creditCardSecurityCodeErrors"
                    :key="error"
                    class="invalid_feedback "
                  >
                    {{ error }}
                  </div>
                </div>
              </div>

              <div
                v-if="selectedPayment && selectedPayment.typeCode === 'JetonCash'"
                class="slider form-input-n2"
              >
                <label class="dp-title">{{ $t('Bao.jeton_label') }}</label>
                <input
                  v-model="Jcash.voucherNumber"
                  type="text"
                  :placeholder="$t('Bao.jeton_voucher')"
                  maxlength="19"
                  @input="checkJetonVoucherErrors"
                >
                <div v-for="error in jetonVoucherErrors" :key="error" class="help-block">
                  {{ error }}
                </div>
                <div class="jcash-container">
                  <div class="jcash-wrap">
                    <!-- Expiration Date Field -->
                    <label class="dp-title">{{ $t('Bao.expiration_date') }}</label>
                    <input
                      v-model="Jcash.expirationDate"
                      maxlength="5"
                      type="text"
                      :placeholder="$t('Bao.expiration_date_placeholder')"
                      @input="formatJcashExpirationDate"
                    >

                    <div v-for="error in JcashExpirationDateErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                  </div>
                  <div class="jcash-wrap">
                    <!-- Security Code Field -->
                    <label class="dp-title">{{ $t('Bao.security_code') }}</label>
                    <input
                      v-model="Jcash.securityCode"
                      type="text"
                      :placeholder="$t('Bao.security_code_placeholder')"
                      maxlength="4"
                      @input="formatJcashSecurityCode"
                    >

                    <div v-for="error in JcashSecurityCodeErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                  </div>
                </div>

                <label class="dp-title">{{ $t('Bao.currency') }}</label>
                <select id="Jcash_EUR" v-model="Jcash.currency" class="crypto-items">
                  <option value="EUR">
                    EUR
                  </option>
                </select>

                <label class="dp-title">  {{ $t('Bao.amount') }} </label>
                <input
                  v-model="cryptoAmount"
                  :placeholder="$t('Bao.crypto_placeholder')"
                  type="text"
                  @input="validateNumber"
                >
                <!--加密貨幣匯率換算 -->
                <div class="crypto">
                  <div class="crypto-infor">
                    <div>{{ $t('Bao.current_rate') }}:</div>
                    <div v-if="!timeLeft" class="exchange-rate-box-n">
                      <div class="exchange-rate">
                        <span class="crypto-amount"> {{ $t('Bao.expired_rate', { crypto: "EUR€" }) }}</span>
                      </div>
                    </div>
                    <div v-if="timeLeft > 0" class="exchange-rate-box-n">
                      <div class="exchange-rate">
                        <span class="crypto-amount"> 1EUR€ = {{ currencyRate.deposit_rate }}JPY</span>
                      </div>
                    </div>
                    <div v-if="timeLeft > 0" class="exchange-rate-box-n">
                      <div class="exchange-rate">
                        <span class="crypto-amount">
                          {{ cryptoAmount }} EUR€ = {{ currencyRate.currencyRate }}JPY
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="recheck-bn">
                    <div v-if="timeLeft > 0" div class="countdown-box">
                      {{ formattedTime }}
                    </div>
                    <div v-else @click="handleRecheck(selectedPayment.payment_id)">
                      {{ $t('Bao.refresh_rate') }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="selectedPayment && selectedPayment.name === 'JetonPay'"
                class="slider form-input-n2"
              >
                <label class="dp-title">{{ $t('Bao.jeton_account') }}</label>
                <input
                  v-model="Jcash.voucherNumber"
                  type="text"
                  :placeholder="$t('Bao.jeton_account')"
                  @input="checkJetonErrors"
                >
                <div v-for="error in jetonErrors" :key="error" class="help-block">
                  {{ error }}
                </div>
              </div>
              <div
                v-if="selectedPayment && selectedPayment.name === 'VegaWallet'"
                class="slider form-input-n2"
              >
                <label class="dp-title">{{ $t('Bao.deposit_account') }}</label>
                <input
                  v-model="other.uid"
                  type="text"
                  :placeholder="$t('Bao.deposit_account')"
                  @input="checkAccountErrors"
                >
                <div v-for="error in accountErrors" :key="error" class="help-block">
                  {{ error }}
                </div>
                <label class="dp-title">{{ $t('Bao.deposit_password') }}</label>
                <input
                  v-model="other.password"
                  v-validate="'required'"
                  name="password"
                  type="password"
                  :placeholder="$t('Bao.deposit_password')"
                >
                <div v-if="errors.has('password')" class="help-block">
                  {{ $t("Bao.deposit_password_error") }}
                </div>
              </div>
            </div>

            <!-- 加密貨幣渠道下拉選單-->
            <div class="slider">
              <div v-show="selectedPayment && selectedPayment.typeNum===3" class="form-input-n2">
                <label class="dp-title">{{ $t('Bao.currency') }}</label>
                <crypto-selector
                  v-model="selectedCrypto"
                  :filtered-types="filteredTypes"
                  @change="handleCryptoSelection"
                />

                <label class="dp-title">  {{ $t('Bao.amount') }} </label>
                <input v-model="cryptoAmount" class="crypto_amount" :placeholder="$t('Bao.crypto_placeholder')" type="text" @input="validateNumber">
                <label class="crypto_amount_jpy">JPY</label>
              </div>

              <!--加密貨幣匯率換算 -->
              <div v-if="selectedPayment && selectedPayment.typeNum===3" class="crypto">
                <div class="crypto-infor">
                  <div>{{ $t('Bao.current_rate') }}:</div>
                  <div v-if="!timeLeft" class="exchange-rate-box-n">
                    <div class="exchange-rate">
                      <span class="crypto-amount"> {{ $t('Bao.expired_rate', { crypto: currencyRate.fetchName }) }}</span>
                    </div>
                  </div>
                  <div v-if="timeLeft > 0" class="exchange-rate-box-n">
                    <div class="exchange-rate">
                      <span class="crypto-amount"> 1 JPY = {{ currencyRate.deposit_divide }}{{ currencyRate.fetchName }}</span>
                    </div>
                  </div>
                  <div v-if="timeLeft > 0" class="exchange-rate-box-n">
                    <div class="exchange-rate">
                      <span class="crypto-amount"> {{ cryptoAmount }} JPY = {{ currencyRate.currencyRate }} {{ currencyRate.fetchName }}</span>
                    </div>
                  </div>
                </div>
                <div class="recheck-bn">
                  <div v-if="timeLeft > 0" div class="countdown-box">
                    {{ formattedTime }}
                  </div>
                  <div v-else @click="handleRecheckFortype3(currencyRate.payment_id)">
                    {{ $t('Bao.refresh_rate') }}
                  </div>
                </div>
              </div>

              <div class="bank-promo-n">
                <template v-if="selectedPayment && selectedPayment.typeCode === 'PayPal'">
                  <p class="channel-text-n">
                    {{ $t('Bao.prize_select') }}
                  </p>

                  <ul class="amount-bn">
                    <li
                      v-for="(price, key) in selectedPayment.price_list"
                      :key="key"
                      :class="selectedAmount === price ? 'active' : ''"
                      @click="handleAmount(price)"
                    >
                      ¥{{ price }}
                    </li>
                  </ul>
                </template>
              </div>

              <!-- pc 電子錢包+銀行 入金價格選項 -->
              <template
                v-if="selectedPayment && (selectedPayment.typeNum !== 3 && selectedPayment.typeCode !== 'PayPal'&& selectedPayment.typeCode !== 'JetonCash'|| selectedPayment.code === 'HeroPay')"
              >
                <div
                  class="slider-number"
                >
                  <li
                    v-for="(price, key) in selectedPayment.price_list.slice(0,5)"
                    :key="key"
                    @click="handleAmount(price)"
                  >
                    {{ price | numberFormat }}
                  </li>
                </div>
                <div class="slider-dot">
                  <li
                    v-for="(price, key) in selectedPayment.price_list.slice(0,5)"
                    :key="key"
                    @click="handleAmount(price)"
                  >
                    <img :src="getThemeImagePath('dot.svg')" alt="">
                  </li>
                </div>

                <div class="slider-bar" />
                <div v-show="selectedAmount" class="slider-bar og" :style="{ width: percent + '%' }">
                  <img :src="getThemeImagePath('dot-orange.svg')" alt="">
                </div>
              </template>

              <div v-if="memberInfo.member_type !== 3 && sortedEvents" class="bank-promo-n">
                <p class="channel-text-n">
                  {{ $t('Bao.available_event') }}
                </p>
                <div class="bank-promo-frame">
                  <div class="bank-promo-box">
                    <swiper
                      ref="mySwiper"
                      class="slick-frame"
                      :options="swiperOption"
                      :up-text="upText"
                    >
                      <swiper-slide
                        v-for="(item, key) in sortedEvents"
                        :key="key"
                        class="event-pic"
                        :class="{
                          'unopened-event': isUnopenedEvent(item),
                          'unselected': !isUnopenedEvent(item),
                          'selected': item.select && selectedEvent !== null
                        }"
                      >
                        <span @click="handleEvent(item)" />
                        <img :src="item.image_deposit" @click="handleEvent(item)">
                      </swiper-slide>

                      <div slot="pagination" class="swiper-pagination" />
                      <div slot="button-prev" class="swiper-button-prev pro-arrow" />
                      <div slot="button-next" class="swiper-button-next pro-arrow" />
                    </swiper>
                  </div>
                </div>
              </div>
              <!--存款計算項目 -->

              <div
                v-show="selectedPayment && selectedPayment.typeNum !== 3"
                class="deposit-frame-n"
              >
                <div class="deposit-detail-n">
                  <div class="list">
                    <b>{{ $t('Bao.deposit_amount') }}</b>
                    <span v-if="selectedCrypto">{{ currencyRate.currencyRate | numberFormat }}</span>
                    <span v-else>{{ postForm.amount | numberFormat }}</span>
                    <span>{{ currency }} </span>
                  </div>
                  <div
                    v-if="!selectedEvent || selectedEvent.type !== 'daily_multiple_deposit'"
                    class="list"
                  >
                    <b>{{ $t('Bao.event_bonus') }}</b>
                    <span>{{ eventBonus | numberFormat }}</span>
                    <span>{{ currency }} </span>
                  </div>
                  <div
                    v-if="!selectedEvent || selectedEvent.type !== 'daily_multiple_deposit'"
                    class="list"
                  >
                    <b>{{ $t('Bao.deposit_total_tip') }}</b>
                    <span>{{ calculateTotalBonus() | numberFormat }}</span>
                    <span>{{ currency }} </span>
                  </div>
                </div>

                <div v-if="selectedPayment" class="deposit-detail-n">
                  <p v-if="selectedEvent && selectedEvent.type === 'daily_multiple_deposit'">
                    {{ $t('Bao.deposit_credit') }} {{ count }}
                    <br>
                    {{ $t('Bao.deposit_credit_illustrate') }}
                    <br>
                    <br>
                    <template v-if="selectedPayment.typeNum === 3">
                      {{ $t('Bao.payment_crypto_describe_1') }}
                    </template>
                    <template v-else-if="selectedPayment.name === 'VegaWallet'">
                      {{ $t('Bao.payment_vega_describe_1') }}
                      <br>
                      {{ $t('Bao.payment_vega_describe_2') }}
                      <a
                        href="https://vega-wallet.com/whitelist/"
                        target="_blank"
                        class="blue-link"
                      >
                        {{ $t('Bao.payment_vega_describe_3') }}
                      </a>
                    </template>
                    <template v-else>
                      {{ $t('Bao.payment_bank_describe_1') }}
                      <br>
                      {{ $t('Bao.payment_bank_describe_2') }}
                    </template>
                  </p>
                  <p v-else-if="selectedPayment.name === 'VegaWallet'">
                    {{ $t('Bao.payment_vega_describe_1') }}
                    <br>
                    {{ $t('Bao.payment_vega_describe_2') }}
                    <a
                      href="https://vega-wallet.com/whitelist/"
                      target="_blank"
                      class="blue-link"
                    >
                      {{ $t('Bao.payment_vega_describe_3') }}
                    </a>
                  </p>
                  <p v-else-if="selectedPayment.typeNum === 3">
                    {{ $t('Bao.payment_crypto_describe_1') }}
                  </p>

                  <p v-else>
                    {{ $t('Bao.payment_bank_describe_1') }}
                    <br>
                    {{ $t('Bao.payment_bank_describe_2') }}
                  </p>
                </div>
              </div>

              <div class="bank-promo-n">
                <button class="button-style-16" :disabled="isButtonDisable" @click="checkIsDeposit()">
                  <span>{{ $t('Bao.deposit') }}</span>
                  <span
                    v-show="postForm.amount !== 0 && selectedPayment && selectedPayment.typeNum!==3 && selectedPayment.typeCode !== 'JetonCash'"
                  >
                    {{ currency }}
                  </span>
                  <span v-if="selectedPayment && selectedPayment.typeNum===3">
                    {{ formatCryptoAmount() }}{{ currency }}JPY
                  </span>
                  <span v-else-if="selectedPayment && selectedPayment.typeCode === 'JetonCash'">
                    {{ postForm.amount | numberFormat }} EUR€
                  </span>
                  <span v-else>
                    {{ postForm.amount | numberFormat }}
                  </span>
                </button>
                <a
                  class="help-deposit-n"
                  @click="$router.push('/page/support')"
                >
                  <span class="icon-help">?</span>
                  <span class="help-text">{{ $t('Bao.deposit_guide') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModel" class="popup-wrap" :class="{ active: showModel }">
      <div class="popup-box">
        <div class="popup-success deposit">
          <h5>
            {{ $t('Bao.is_handle_deposit') }}
          </h5>
          <button class="button-style-5" @click="handleSubmit">
            <span>{{ $t('Bao.submit') }}</span>
          </button>
          <button class="button-style-5" @click="hideModel">
            <span>{{ $t('Bao.cancel') }}</span>
          </button>
        </div>
        <a class="popup-close" @click="hideModel" />
      </div>
    </div>
    <div v-if="showCVV" class="popup-frame popup-card-cvv" :class="{'active': showCVV}">
      <cardCVV v-if="showCVV" @closeCVV="closeCVV" />
    </div>
  </div>
</template>

<script>
import { showNotice, setErrorMessage, getThemeImagePath } from '@/utils/tool'
import cardCVV from '@/components/modal/cardCVV'
import cryptoSelector from '@/components/modal/cryptoSelector'
import {
  DepositType,
  DepositPayment,
  DepositSetting,
  DepositTransactions,
  checkDepositRate,
  checkDepositCryptoRate
} from '@/api/payment'
import { getMyCreditCards } from '@/api/bank'
import { page } from '@/api/common'
import { getEvent, getEventDetail, joinEvent, getEventQualification } from '@/api/event'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import crypto from 'crypto-js'

export default {
  components: {
    Swiper,
    SwiperSlide,
    cardCVV,
    cryptoSelector
  },
  data() {
    const postForm = {
      payment_id: null,
      amount: 0,
      userName: '',
      join_event_info: [],
      event_type: null,
      default: null
    }
    return {
      other: [],
      cryptoAmount: '',
      selectedType: null,
      outerTypes: [],
      types: [],
      selectedPayment: null,
      postForm,
      events: [],
      eventBonus: 0,
      selectedEvent: null,
      deposit_v2: null,
      selectedAmount: null,
      selectedCrypto: {},
      selectedTypeName: '',
      selectedTypeCode: '',
      showCVV: false,
      percent: 0,
      isDepositEventsVisible: true,
      swiperOption: {
        slidesPerView: 3.5,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionPhone: {
        slidesPerView: 1.3,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      upText: this.$t('Bao.select_event'),
      itemSelect: false,
      count: 0,
      multipleDeposit: [],
      bounsLowerLimit: 0,
      todayArr: [],
      checkQual: true,
      lastResponseMessage: '',
      timer: null,
      timeLeft: 0, // 5 minutes in seconds
      accountErrors: [],
      jetonErrors: [],
      jetonVoucherErrors: [],
      JcashExpirationDateErrors: [],
      JcashSecurityCodeErrors: [],
      creditCardNameErrors: [],
      creditCardNumErrors: [],
      creditCardExpirationDateErrors: [],
      creditCardSecurityCodeErrors: [],
      selectedCreditCard: null,
      depositEventRule: '',
      depositConfirmMessage: '',
      Jcash: {
        voucherNumber: '',
        expirationDate: '',
        securityCode: '',
        currency: ''
      },
      creditCard: {
        card_printed_name: '',
        credit_card_number: '',
        expirationDate: '',
        securityCode: ''
      },
      showModel: false
    }
  },
  computed: {
    currencyRate() {
      let isCheck
      if (this.selectedPayment && (this.selectedPayment.typeCode === 'JetonCash' || this.selectedPayment.typeNum === 3)) {
        isCheck = this.types.find(type => type.typeName === this.selectedCrypto.typeName)
      }
      if (isCheck) {
        let exchangeRate
        if (this.selectedPayment.typeNum === 3) {
          exchangeRate = this.cryptoAmount / isCheck.deposit_rate
        } else {
          exchangeRate = this.cryptoAmount * isCheck.deposit_rate
        }

        if (exchangeRate % 1 !== 0) {
          return {
            currencyRate: exchangeRate.toFixed(4),
            deposit_rate: isCheck.deposit_rate,
            deposit_divide: 1 / isCheck.deposit_rate,
            payment_id: isCheck.payment_id,
            fetchName: isCheck.typeName
          }
        } else {
          return {
            currencyRate: exchangeRate,
            deposit_rate: isCheck.deposit_rate,
            deposit_divide: 1 / isCheck.deposit_rate,
            payment_id: isCheck.payment_id,
            fetchName: isCheck.typeName
          }
        }
      }
      return {
        currencyRate: 0,
        deposit_rate: 0,
        payment_id: 0
      }
    },
    filteredTypes() {
      if (this.selectedPayment) {
        return this.types
          .filter(type => type.typeNum === 3)
          .filter(type => type.name === this.selectedPayment.name)
      } return []
    },
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60)
      const seconds = this.timeLeft % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    isButtonDisable() {
      const num = parseInt(this.postForm.amount, 10)
      const isInvalidAmount = isNaN(num) || num <= 0
      const cryptonNum = parseFloat(this.cryptoAmount)
      const isInvalidCryptonNumAmount = isNaN(cryptonNum) || cryptonNum <= 0
      const isDailyMultipleDeposit =
        this.selectedEvent && this.selectedEvent.type === 'daily_multiple_deposit' &&
        this.selectedPayment && num < this.bounsLowerLimit

      if (this.selectedCrypto && this.selectedCrypto.typeCode !== 'JetonCash') {
        return this.postForm.payment_id === null || isInvalidCryptonNumAmount || !this.timeLeft ||
              (this.selectedEvent && this.selectedEvent.type === 'daily_multiple_deposit' &&
               this.selectedPayment &&
               parseInt(this.currencyRate.currencyRate, 10) < this.bounsLowerLimit)
      }

      if (this.selectedPayment && this.selectedPayment.name === 'VegaWallet') {
        const accountErrors = this.accountErrors
        return this.postForm.payment_id === null || isInvalidAmount || isDailyMultipleDeposit ||
              !this.other.password || accountErrors.length > 0
      } else if (this.selectedPayment && this.selectedPayment.name === 'JetonPay') {
        const accountErrors = this.jetonErrors
        return this.postForm.payment_id === null || isInvalidAmount || isDailyMultipleDeposit || !this.other.uid || accountErrors.length > 0
      } else if (this.selectedPayment && this.selectedPayment.typeCode === 'JetonCash') {
        return this.postForm.payment_id === null || isDailyMultipleDeposit ||
               this.jetonVoucherErrors.length > 0 || this.JcashExpirationDateErrors.length > 0 ||
               this.JcashSecurityCodeErrors.length > 0 ||
              !this.Jcash.voucherNumber || !this.Jcash.expirationDate ||
              !this.Jcash.securityCode || !this.Jcash.currency || isInvalidAmount
      } else if (this.selectedPayment && this.selectedPayment.typeCode === 'CreditCard' && this.selectedPayment.code !== 'HeroPay') {
        return this.postForm.payment_id === null || isDailyMultipleDeposit ||
               this.creditCardNameErrors.length > 0 || this.creditCardNumErrors.length > 0 ||
               this.creditCardExpirationDateErrors.length > 0 ||
               this.creditCardSecurityCodeErrors.length > 0 ||
               this.creditCard.credit_card_number.length === 0 || !this.creditCard.expirationDate ||
              !this.creditCard.securityCode || isInvalidAmount ||
              !this.creditCard.card_printed_name
      }

      return this.postForm.payment_id === null || isInvalidAmount || isDailyMultipleDeposit
    },
    sortedEvents() {
      const events = [...this.user.sortedEvents]
      const allUnopened = events.every(event => this.isUnopenedEvent(event))
      if (allUnopened) return null

      return events.sort((a, b) => {
        if (this.isUnopenedEvent(a) && !this.isUnopenedEvent(b)) {
          return 1 // a is unopened, b is not, a goes behind b
        } else if (!this.isUnopenedEvent(a) && this.isUnopenedEvent(b)) {
          return -1 // a is not unopened, b is, a goes in front of b
        }
        return 0 // both are either unopened or not, keep original order
      })
    },
    activityCount() {
      if (this.multipleDeposit) {
        return this.multipleDeposit.setting.reduce((count, week) => {
          if (week.condition_value === this.getDayNumber()) {
            return count + 1
          }
          return count
        }, 0)
      }
      return 0
    },
    swiper() {
      return this.sortedEvents ? this.$refs.mySwiper.$swiper : null
    },
    swiperPhone() {
      return this.sortedEvents ? this.$refs.mySwiperPhone.$swiper : null
    },
    user() {
      return this.$store.state.user
    },
    memberInfo() {
      return this.user.memberInfo
    },
    first_deposit_at() {
      return this.memberInfo.first_deposit_at
    },
    brand() {
      return this.$store.state.brand
    },
    currency() {
      return this.brand.currency
    },
    before_withdrawal_module_setting() {
      return this.brand.info.before_withdrawal_module_setting
    }
  },
  watch: {
    selectedEvent() {
      this.calculateBonus()
    },
    selectedCreditCard() {
      // Extract month and year
      const month = this.selectedCreditCard.expire_month
      const year = this.selectedCreditCard.expire_year

      // Format the expiration date
      this.creditCard.expirationDate = this.formatCardExpirationDateWhenSelect(month, year)
      this.creditCard.card_printed_name = this.selectedCreditCard.card_printed_name
    },
    'postForm.amount'() {
      this.calculateBonus()
    },
    'cryptoAmount'() {
      this.calculateBonus()
    },
    selectedCrypto(newValue, oldValue) {
      if (newValue) {
        this.resetTimer()
      }
    },
    filteredTypes(newVal) {
      if (newVal.length > 0) {
        this.selectedCrypto = newVal[0]
      }
    }
  },
  created() {
    DepositType()
      .then((response) => {
        // Flatten the types and their payments into a single array
        // where each payment item includes its parent type's information.
        const flattenedPayments = response.data.data.reduce((acc, type) => {
          // Map each payment to include type information
          const paymentsWithTypeInfo = type.payments.map(payment => ({
            ...payment, // Include all properties of the payment
            typeName: type.name,
            typeCode: type.code,
            typeNum: type.type,
            typeImage: type.image,
            typeHey: type.hey
          }))
          return acc.concat(paymentsWithTypeInfo)
        }, [])

        // Group payments by type
        const groupedPayments = flattenedPayments.reduce((acc, payment) => {
          const existingType = acc.find(item => item.type === payment.typeNum)

          if (existingType) {
            const existingPayment = existingType.paymentMethods.find(pm => pm.name === payment.name)
            if (!existingPayment) {
              existingType.paymentMethods.push(payment)
            }
          } else {
            acc.push({
              type: payment.typeNum,
              paymentMethods: [payment]
            })
          }
          return acc
        }, [])

        const predefinedTypes = [
          { type: 2, paymentMethods: [] },
          { type: 1, paymentMethods: [] },
          { type: 3, paymentMethods: [] },
          { type: 4, paymentMethods: [] }
        ]

        // Merge actual data into the predefined structure
        this.outerTypes = predefinedTypes.map(predefType => {
          const actualType = groupedPayments.find(group => group.type === predefType.type)
          return actualType || predefType // Use actual type if found, otherwise use empty predefined type
        })

        this.outerTypes.forEach(type => {
          type.paymentMethods = type.paymentMethods.filter(payment =>
            payment.allow_member_level.includes(String(this.memberInfo.vl)) &&
            payment.typeHey === this.memberInfo.vip_level_id
          )
        })
        this.types = flattenedPayments
      })
      .catch(() => {
        // Handle error
      })
    getMyCreditCards().then((response) => {
      this.creditCard.credit_card_number = response.data.data
    })

    page({ type: 'deposit_event_rule' }).then(response => {
      this.depositEventRule = response.data.data.content
    })
    page({ type: 'deposit_confirm_message' }).then(response => {
      this.depositConfirmMessage = response.data.data.content
    })

    getEvent()
      .then((response) => {
        for (const item of response.data.data.list) {
          if (item.is_show_in_deposit !== 0) {
            if (item.type === 'deposit_v2') {
              this.events.push(item)
              this.deposit_v2 = item.id
            }
            if (item.is_show_in_deposit === 1) {
              if (item.type === 'daily_multiple_deposit' && this.memberInfo.third_deposit_amount !== 0) {
                this.getTransactions()
                this.events.push(item)
              } else if (item.type !== 'deposit_v2' && item.type !== 'daily_multiple_deposit') {
                this.events.push(item)
              }
            }
          }
        }
        this.$store.dispatch('initializeSortedEvents', this.events)
        for (const i in this.events) {
          getEventDetail(this.events[i].id).then(response => {
            const event = response.data.data
            if (event.type === 'daily_multiple_deposit') {
              this.multipleDeposit = event
              event.setting.forEach(item => {
                if (item.condition_value === this.getDayNumber()) {
                  this.todayArr.push(item)
                }
              })
            }
            event.select = false
            this.events.splice(i, 1, event)
          })
        }
        if (this.sortedEvents) {
          this.updateSwiperWrapperStyle()
        }
      })
    DepositSetting()
      .then((response) => {
        this.postForm.default = parseInt(parseFloat(response.data.data.info.default_deposit_amount))
      }).catch((error) => {
        const result = error.response.data
        if (result.status === 403) {
          showNotice(result.msg, () => {
            this.$router.push('/')
          })
        }
      })
  },
  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    updateSwiperWrapperStyle() {
      this.$nextTick(() => {
        const swiperWrapper = this.swiper.$wrapperEl[0]
        const swiperPhoneWrapper = this.swiperPhone.$wrapperEl[0]

        if (swiperWrapper && this.sortedEvents.length < 4) {
          swiperWrapper.style.display = 'flex'
          swiperWrapper.style.justifyContent = 'center'

          const slides = swiperWrapper.querySelectorAll('.swiper-slide')
          slides.forEach(slide => {
            slide.style.marginLeft = '30px'
          })
        }

        if (swiperPhoneWrapper && this.sortedEvents.length < 2) {
          swiperPhoneWrapper.style.display = 'flex'
          swiperPhoneWrapper.style.justifyContent = 'center'

          const slides = swiperPhoneWrapper.querySelectorAll('.swiper-slide')[0]
          slides.style.margin = 'auto'
        }
      })
    },
    checkJetonErrors() {
      this.jetonErrors = []
      if (!this.other.uid) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      } else if (!/^\d+$/.test(this.other.uid)) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      }
    },
    checkCreditCardNameErrors() {
      const errorMessage = this.$t('Bao.credit_card_name_error')

      if (!this.creditCard.card_printed_name) {
        // Check if the error message is not already in the array
        if (!this.creditCardNameErrors.includes(errorMessage)) {
          this.creditCardNameErrors.push(errorMessage)
        }
      } else {
        // Remove the error message if the input is not empty
        const index = this.creditCardNameErrors.indexOf(errorMessage)
        if (index !== -1) {
          this.creditCardNameErrors.splice(index, 1)
        }
      }
    },
    checkJetonVoucherErrors() {
      this.jetonVoucherErrors = []
      const input = this.Jcash.voucherNumber.replace(/\D/g, '') // Remove non-digits
      this.Jcash.voucherNumber = input.slice(0, 19) // Limit to 19 digits(0, 19)
      if (this.Jcash.voucherNumber.length < 19) {
        this.jetonVoucherErrors.push(this.$t('Bao.jeton_voucher_error'))
      }
    },
    formatCardExpirationDateWhenSelect(month, year) {
      // Ensure month is two digits
      const formattedMonth = month.padStart(2, '0')

      // Extract last two digits of the year
      const formattedYear = year.slice(-2)

      return `${formattedMonth}/${formattedYear}`
    },
    formatCreditCardExpirationDate(event) {
      this.formatExpirationDate(event, 'creditCard')
    },

    formatJcashExpirationDate(event) {
      this.formatExpirationDate(event, 'Jcash')
    },

    formatExpirationDate(event, field) {
      let input = event.target.value.replace(/\D/g, '') // Remove non-digits
      if (input.length > 2) {
        input = input.slice(0, 2) + '/' + input.slice(2)
      }
      this[field].expirationDate = input
      this.checkExpirationDateErrors(field)
    },
    checkExpirationDateErrors(field) {
      const errorField = `${field}ExpirationDateErrors`
      this[errorField] = []
      const [month, year] = this[field].expirationDate.split('/')

      if (this[field].expirationDate.length < 5) {
        // Don't show error if the user hasn't finished typing
        return
      }

      this[field].expiryMonth = month
      this[field].expiryYear = `20${year}`

      if (!/^\d{2}\/\d{2}$/.test(this[field].expirationDate)) {
        this[errorField].push(this.$t('Bao.expiration_date_error'))
      } else if (parseInt(month) < 1 || parseInt(month) > 12) {
        this[errorField].push(this.$t('Bao.expiration_date_error'))
      } else {
        // Check if the expiration date is in the past
        const currentDate = new Date()
        const expirationDate = new Date(parseInt(`20${year}`), parseInt(month) - 1)

        if (expirationDate < currentDate) {
          this[errorField].push(this.$t('Bao.expiration_date_past_error'))
        }
      }
    },
    formatCreditCardSecurityCode(event) {
      this.formatSecurityCode(event, 'creditCard')
    },
    formatJcashSecurityCode(event) {
      this.formatSecurityCode(event, 'Jcash')
    },
    formatSecurityCode(event, field) {
      const input = event.target.value.replace(/\D/g, '') // Remove non-digits
      this[field].securityCode = input.substr(0, 4)
      this.checkSecurityCodeErrors(field)
    },

    checkSecurityCodeErrors(field) {
      const errorField = `${field}SecurityCodeErrors`
      this[errorField] = []
      if (field === 'Jcash' && this[field].securityCode.length < 4) {
        this[errorField].push(this.$t('Bao.security_code_error'))
        return
      }
      if (field === 'creditCard' && this[field].securityCode.length < 3) {
        this[errorField].push(this.$t('Bao.security_code_error'))
        return
      }
      // if (!/^\d{4}$/.test(this[field].securityCode)) {
      //   this[errorField].push(this.$t('Bao.security_code_error'))
      // }
    },
    checkAccountErrors() {
      this.accountErrors = []
      if (!this.other.uid) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      } else if (!/^[a-zA-Z]\d{6}$/.test(this.other.uid)) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      }
    },
    selectType(type) {
      // Toggle type selection (click again to deselect)
      this.selectedType = type
      // Reset selected payment when changing type
      this.postForm.amount = this.postForm.default
      this.cryptoAmount = ''
      this.selectedAmount = 0
      this.selectedPayment = null
      this.postForm.payment_id = null

      if (this.selectedType.type === 3) {
        this.postForm.amount = 0
      }
    },
    selectPayment(payment, name, code) {
      this.percent = 0
      this.postForm.amount = this.postForm.default
      if (payment.typeCode === 'JetonCash') {
        this.selectedCrypto = payment
      } else {
        this.selectedCrypto = null
      }
      this.selectedTypeCode = code
      this.selectedPayment = payment
      this.postForm.payment_id = payment.payment_id
      this.selectedTypeName = name
      if (code === 'BankToBank') {
        if (!this.memberInfo.romanization) {
          showNotice(this.$t('Bao.credit_card_notice1'), () => {
            this.$router.push({
              path: '/user/edit'
            })
          })
        }
      }
      if (code === 'CreditCard' && this.creditCard.credit_card_number.length === 0 && this.selectedPayment.code !== 'HeroPay') {
        showNotice(this.$t('Bao.credit_card_notice'), () => {
          this.$router.push({
            path: '/user/bank/create',
            query: { selectType: 4 }
          })
        })
      }
    },
    isSelectedPayment(payment) {
      return this.selectedPayment && this.selectedPayment.payment_id === payment.payment_id
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    handleRecheckFortype3(payment_id) {
      this.postForm.payment_id = payment_id
      this.fetchRealtimeCryptoRate(payment_id)
    },
    handleRecheck(payment_id) {
      this.postForm.payment_id = payment_id
      this.fetchCurrentRate(payment_id)
    },
    resetTimer() {
      clearInterval(this.timer)
      this.timeLeft = 0
    },
    closeCVV() {
      this.showCVV = false
    },
    fetchCurrentRate(payment_id) {
      checkDepositRate(payment_id)
        .then(response => {
          if (response.data.data === null) {
            showNotice(this.$t('Bao.crypto_fail'))
          } else {
            const matchCurrency = this.types.find(type => type.payment_id === payment_id)
            let newRate = response.data.data[matchCurrency.typeCode]
            if (matchCurrency.typeCode === 'JetonCash') {
              this.selectedCrypto = matchCurrency
              newRate = response.data.data['EUR']
            }
            matchCurrency.deposit_rate = newRate
            this.postForm.amount = this.cryptoAmount
          }
        }).then(() => {
          this.timeLeft = 300
          this.startCountdown()
        })
    },
    fetchRealtimeCryptoRate(payment_id) {
      checkDepositCryptoRate(payment_id)
        .then(response => {
          if (response.data.data === null) {
            showNotice(this.$t('Bao.crypto_fail'))
          } else {
            // const matchCurrency = this.types.find(type => type.payment_id === payment_id)
            const newRate = response.data.data.deposit_rate
            // if (matchCurrency.typeCode === 'JetonCash') {
            //   this.selectedCrypto = matchCurrency.typeName
            //   newRate = response.data.data['EUR']
            // }
            this.selectedCrypto.deposit_rate = newRate
            this.postForm.amount = this.cryptoAmount
          }
        }).then(() => {
          this.timeLeft = 300
          this.startCountdown()
        })
    },
    handleCryptoSelection() {
      if (this.selectedCrypto) {
        this.postForm.payment_id = this.selectedCrypto.payment_id
      }
    },
    formatCryptoAmount() {
      const num = Number(this.cryptoAmount)
      const decimalPlaces = (num.toString().split('.')[1] || '').length
      return decimalPlaces > 8 ? num.toFixed(8) : num.toFixed(decimalPlaces)
    },
    showDepositText() {
    // 獎勵充值下限
      this.todayArr.forEach(item => {
        if (item.condition_value_2 === this.count + 1) {
          this.bounsLowerLimit = item.condition_value_3
        }
      })
      if (this.selectedEvent && this.selectedEvent.type === 'daily_multiple_deposit' &&
          this.selectedPayment && this.postForm.amount < this.bounsLowerLimit) {
        return true
      }
      return false
    },
    isUnopenedEvent(item) {
      const type = item.type
      if (type === 'manual_first_deposit_v2' && this.memberInfo.first_deposit_amount !== 0) return true
      if (type === 'manual_first_deposit' && this.memberInfo.first_deposit_amount !== 0) return true
      if (type === 'manual_second_deposit' && this.memberInfo.second_deposit_amount !== 0) return true
      if (type === 'manual_third_deposit' && this.memberInfo.third_deposit_amount !== 0) return true

      if (type === 'daily_multiple_deposit' && this.multipleDeposit.length !== 0) {
        if (this.count >= this.activityCount) {
          return true
        }
      }
      return false
    },
    handleEvent(item) {
      if (this.isUnopenedEvent(item)) {
        item.select = false
        this.selectedEvent = null
        return
      } else if (this.selectedEvent && this.selectedEvent.id === item.id) {
        // If the same event is clicked again, toggle select
        item.select = !item.select
        if (item.select) {
          this.checkQualification(item)
        }
      } else {
        // If a different event is clicked, select it and deselect the previous one
        if (this.selectedEvent) {
          this.selectedEvent.select = false
        }
        item.select = true
        this.checkQualification(item)
      }

      setTimeout(() => {
        this.selectedEvent = item.select ? item : null
        this.$store.dispatch('selectEvent', item.id)
      }, 0.5)

      if (item.type === 'daily_multiple_deposit') {
        this.postForm.join_event_info = JSON.stringify([{ 'type': 'daily_multiple_deposit' }])
        this.showDepositText()
      } else {
        this.postForm.join_event_info = JSON.stringify([{ 'type': item.type }])
      }

      if (this.selectedEvent && this.selectedEvent.id === this.deposit_v2) {
        this.postForm.event_type = 'deposit_v2'
        this.postForm.event_join = true
      }
    },
    getTransactions() {
      var today = new Date()
      today.setHours(0, 0, 0, 0)
      var midnightTimestamp = today.getTime()
      var timestampInSeconds = Math.floor(midnightTimestamp / 1000)
      var currentTime = Math.floor(Date.now() / 1000)

      DepositTransactions({ start_at: timestampInSeconds, end_at: currentTime }).then(response => {
        response.data.data.list.forEach(item => {
        // 到帳次數（扣除首存、二存、三存、特規首存）
          if (item.setting === null) {
            this.count++
          } else if (item.setting !== null && item.setting.event) {
            item.setting.event.forEach(event => {
              if (event.type !== 'manual_first_deposit' && event.type !== 'manual_second_deposit' &&
                  event.type !== 'manual_third_deposit' && event.type !== 'custom_first_deposit') {
                this.count++
              }
            })
          }
        })
      })
    },
    handleAmount(amount) {
      this.postForm.amount = amount
      this.selectedAmount = amount

      const getPercentMap = (length) => {
        switch (length) {
          case 3:
            return {
              [this.selectedPayment.price_list[1]]: 48,
              [this.selectedPayment.price_list[2]]: 98
            }
          case 4:
            return {
              [this.selectedPayment.price_list[1]]: 32,
              [this.selectedPayment.price_list[2]]: 65,
              [this.selectedPayment.price_list[3]]: 98
            }
          case 5:
            return {
              [this.selectedPayment.price_list[1]]: 24,
              [this.selectedPayment.price_list[2]]: 49,
              [this.selectedPayment.price_list[3]]: 73,
              [this.selectedPayment.price_list[4]]: 98
            }
          default:
            return {}
        }
      }
      const percentMap = getPercentMap(this.selectedPayment.price_list.length)
      this.percent = percentMap[amount] || 0
      this.cryptoAmount = ''
    },
    calculateBonus() {
      if (this.postForm.amount === '' || isNaN(this.postForm.amount)) return
      const amount = (this.selectedCrypto !== null || this.selectedTypeCode === 'JetonCash') ? this.postForm.amount : parseInt(this.postForm.amount)
      if (this.selectedEvent === null) {
        this.eventBonus = 0
        return
      }

      // deposit_v2: 每日存款活動
      if (this.selectedEvent.type === 'deposit_v2') {
        this.eventBonus = 0
        this.selectedEvent.setting.forEach(item => {
          if (amount <= item.max_deposit_amount && amount >= item.min_deposit_amount) {
            const prize = amount * (item.prize / 100)
            this.eventBonus = parseFloat(prize)
          }
        })
      } else {
        // 加密貨幣 & JetonCash要做換算
        const newAmout = (this.selectedCrypto !== null || this.selectedTypeCode === 'JetonCash') ? amount * this.currencyRate.deposit_rate : amount
        // 活動最低存款金額：condition_value
        if (newAmout < this.selectedEvent.setting[0].condition_value) {
          this.eventBonus = 0
          return
        }
        const conditionValue = parseFloat(this.selectedEvent.setting[0].condition_value_2)
        const bonus = !isNaN(conditionValue) ? amount * (conditionValue / 100) : 0
        // 活動單筆最大獎金上限：condition_value_3
        // 加密貨幣 & JetonCash要做換算
        const cryptoBonus = (this.selectedCrypto !== null || this.selectedTypeCode === 'JetonCash') ? bonus * this.currencyRate.deposit_rate : bonus
        this.eventBonus = cryptoBonus > this.selectedEvent.setting[0].condition_value_3 ? this.selectedEvent.setting[0].condition_value_3 : cryptoBonus
      }
    },
    calculateTotalBonus() {
      if (this.postForm.amount === '') {
        return this.eventBonus
      } else if (this.selectedCrypto) {
        return parseFloat(this.currencyRate.currencyRate) + this.eventBonus
      } else {
        return parseInt(this.postForm.amount) + this.eventBonus
      }
    },
    checkQualification(event) {
      getEventQualification(event.type)
        .then(response => {
          const code = response.data.data.code
          this.handleResponseCode(code)
          if (event.type === 'manual_first_deposit_v2') {
            showNotice(this.depositEventRule, null, true, false, '同意する')
          }
        })
        .catch(error => {
          showNotice(error.response.data.msg)
        })
    },
    handleResponseCode(code) {
      this.checkQual = false
      switch (code) {
        case 1001:
          this.lastResponseMessage = 'Bao.special_deposit_err6'
          break
        case 2001:
        case 3001: {
          this.lastResponseMessage = 'Bao.unavailible_3' + code + 'Bao.unavailable_2'
          break
        }
        case 2101:
          this.lastResponseMessage = 'Bao.member_type_not_pass'
          break
        case 5101:
          this.lastResponseMessage = 'Bao.first_deposit_exist'
          break
        case 5102:
          this.lastResponseMessage = 'Bao.first_deposit_not_enough'
          break
        case 5201:
          this.lastResponseMessage = 'Bao.second_deposit_exist'
          break
        case 5202:
          this.lastResponseMessage = 'Bao.second_deposit_not_enough'
          break
        case 5301:
          this.lastResponseMessage = 'Bao.third_deposit_exist'
          break
        case 5302:
          this.lastResponseMessage = 'third_deposit_not_exist'
          break
        default:
          this.checkQual = true
          this.lastResponseMessage = ''
          return
      }

      showNotice(this.$t(this.lastResponseMessage))
    },
    checkIsDeposit() {
      if (this.first_deposit_at === 0 && this.before_withdrawal_module_setting !== null) {
        this.showModel = true
      } else {
        this.handleSubmit()
      }
    },
    handleSubmit() {
      this.showModel = false
      if (!this.checkQual) {
        if (this.lastResponseMessage) {
          showNotice(this.$t(this.lastResponseMessage))
        }
        return
      }
      const self = this
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (this.selectedPayment.id === 'manual') {
            console.log('manual')
          } else {
            if (this.selectedEvent && this.selectedEvent.type !== 'daily_multiple_deposit') {
              joinEvent(this.selectedEvent.id)
                .then(() => {})
                .catch((error) => {
                  showNotice(error.response.data.msg)
                })
            }
          }
        }
      })

      if (this.selectedPayment.name !== 'VegaWallet') {
        var newWindow = window.open('/loading.html', '_blank')
      }

      let encryptedPostForm = { ...this.postForm }

      // 如果支付方式為 'VegaWallet',則加密密碼
      if (this.selectedPayment.name === 'VegaWallet') {
        encryptedPostForm.other = { ...this.other }
        encryptedPostForm.other.password = crypto.MD5(encryptedPostForm.other.password).toString()
      } else if (this.selectedPayment.name === 'JetonPay') {
        encryptedPostForm.other = { ...this.other }
      } else if (this.selectedPayment.typeCode === 'JetonCash') {
        encryptedPostForm = {
          ...encryptedPostForm,
          ...this.Jcash
        }
      } else if (this.selectedPayment.typeCode === 'CreditCard' && this.selectedPayment.code !== 'HeroPay') {
        encryptedPostForm = {
          ...encryptedPostForm,
          ...this.creditCard,
          cvv2: this.creditCard.securityCode,
          credit_card_number: this.selectedCreditCard.credit_card_number,
          member_creditcard_id: this.selectedCreditCard.id
        }
      } else {
        // 其他支付方式,不需要帳號密碼
        delete encryptedPostForm.other
      }

      const encryptedOtherString = JSON.stringify(encryptedPostForm.other)

      // This ensures DepositPayment is always triggered, regardless of validation result
      DepositPayment({ ...encryptedPostForm, other: encryptedOtherString })
        .then((response) => {
          const result = response.data.data

          this.url = result.content
          if (this.selectedPayment.name === 'VegaWallet' || this.selectedPayment.typeCode === 'JetonCash') {
            showNotice(
              this.$t('Bao.deposit_processing_notice_1') + '<br>' + this.$t('Bao.deposit_processing_notice_2'),
              function() {
                self.$router
                  .push({ path: '/user/deposit-record' })
                  .catch(() => {
                  })
              }
            )
            return
          }

          if (newWindow !== undefined) {
            newWindow.location = this.url
            showNotice(
              this.depositConfirmMessage,
              function() {
                self.$router
                  .push({ path: '/user/deposit-record' })
                  .catch(() => {
                  })
              }
            )

            // 偵測新視窗是否關閉
            var startCheck = false
            self.listenTimer = window.setInterval(function() {
              try {
                var newHost = newWindow.location.host
              } catch (e) {
                newHost = 'cross domain'
              }

              console.log('detect..', newHost, startCheck)
              if (newHost !== window.location.host) {
                startCheck = true
              }

              if (newHost === window.location.host && startCheck) {
                newWindow.close()
                window.clearInterval(self.listenTimer)
                self.$router
                  .push({ path: '/user/deposit-record' })
                  .catch(() => {
                  })
              } else if (newWindow.closed) {
                window.clearInterval(self.listenTimer)
                self.$router
                  .push({ path: '/user/deposit-record' })
                  .catch(() => {
                  })
              }
            }, 1000)
          } else {
          // app不另開視窗
            window.location = this.url
          }
        })
        .catch((error) => {
          setErrorMessage(error.response, this.errors)

          if (newWindow !== undefined) {
            newWindow.close()
          }
        })
    },
    validateNumber(event) {
      if (this.selectedPayment.typeNum === 3 || this.selectedPayment.typeCode === 'JetonCash') {
        // Allow only numbers
        event.target.value = event.target.value.replace(/[^\d.]/g, '')
        this.cryptoAmount = event.target.value
        this.postForm.amount = this.cryptoAmount
      } else {
        // Only allow integers
        event.target.value = event.target.value.replace(/[^0-9]/g, '')
        this.postForm.amount = event.target.value
        this.cryptoAmount = ''
      }
    },
    getDayNumber() {
      const currentDate = new Date()
      let dayNumber = currentDate.getDay() // Sunday - 0, Monday - 1, ..., Saturday - 6
      if (dayNumber === 0) {
        dayNumber = 7 // Change Sunday from 0 to 7
      }
      return dayNumber % 7 // Modulo 7 will turn 7 (Sunday) into 0
    },
    hideModel() {
      this.showModel = false
    },
    getThemeImagePath
  }
}
</script>

<style>
  .blue-link {
  color: #007aff;
  cursor: pointer;
  }
  .deposit-detail button:disabled.button-style-7{
    background: #b9b9b9;
  }
  .jcash-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .jcash-wrap {
    display: flex;
    width: 45%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.locked-input {
  background-color: #CECECE !important;
  cursor: not-allowed;
  color:#898989 !important;
}

  .swiper-button-prev.pro-arrow,
  .swiper-button-next.pro-arrow {
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #978564;
	color: #fff;
	cursor: pointer;
	border-radius: 100%;
  }
  .swiper-pagination.swiper-pagination-fraction {
    bottom: 5px;
    width: 30%;
    left: 35%;
  }
  .swiper-button-prev, .swiper-button-next {
    top: 98%;
  }
  .swiper-button-next {
    right: 43%;
  }
  .swiper-button-prev {
    left: 43%;
  }
  .swiper-button-prev:after, .swiper-button-next:after{
    font-size: 10px;
  }
  .swiper-container::before {
      content: attr(up-text);
      position: absolute;
      width: 80%;
      left: 10%;
      top: 4px;
  }
  .swiper-container::after {
    content: attr(down-text);
    position: absolute;
    bottom: 8px;
  }
  .crypto-type{
    white-space: nowrap;
   }
  .crypto-wrap{
    width: 100%;
    text-align: center;
   }
  .rotate-equal {
  display: inline-block;
  transform: rotate(90deg);
   }
   @media (max-width: 992px) {
  .swiper-button-next {
    right: 33%;
    }
  .swiper-button-prev {
    left: 33%;
    }
    .jcash-wrap label.dp-title {
      margin: auto;
    }
  }
  .popup-success.deposit button.button-style-5 {
    margin-left: 10px;
}

</style>

